export default __webpack_public_path__ + "static/bloggingbase-14864a88625453b9654a15e8aededc9d.png";